import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-file-already-exists-action',
  templateUrl: './file-already-exists-action.component.html',
  styleUrls: ['./file-already-exists-action.component.scss']
})
export class FileAlreadyExistsActionComponent implements OnInit {

  title: string = this.data.title;
  message: string = this.data.message;
  constructor(

    public dialog: MatDialogRef<FileAlreadyExistsActionComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    },
  ) { }

  ngOnInit() {

  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(true)
  }
}

